import { defaultValues, RequesterFormContextProvider } from './utils/requesterFormContext'
import { RequesterProps } from './_props'
import { UserFormErrorContextProvider, defaultValues as defaultValuesError } from '../User/utils/userFormErrorContext'
import RequesterFormWrapper from './RequesterFormWrapper'

const Requester = ({ mode, isExternal }: RequesterProps) => (
    <RequesterFormContextProvider initialValues={{ ...defaultValues, isExternal }}>
        <UserFormErrorContextProvider initialValues={defaultValuesError}>
            <RequesterFormWrapper mode={mode} />
        </UserFormErrorContextProvider>
    </RequesterFormContextProvider>
)

export default Requester
